let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eD7wS")).then(() => parcelRequire('geTym'));